export default __webpack_public_path__ + "static/media/half_sangam.cf6c059b.png";